export default "__VITE_PUBLIC_ASSET__f744fe98__"